/* eslint-disable */
import { MODULE_NAME, } from '../constants';

export const GET_HOME_PAGE_INFO = `${MODULE_NAME}/GET_HOME_PAGE_INFO`;
export const GET_HOME_PAGE_INFO_SUCCESS = `${MODULE_NAME}/GET_HOME_PAGE_INFO_SUCCESS`;
export const GET_HOME_PAGE_INFO_ERROR = `${MODULE_NAME}/GET_HOME_PAGE_INFO_ERROR`;
